/*
 * @Author: DESKTOP-FKE5GMS\17601 1760178806@qq.com
 * @Date: 2023-12-08 14:26:09
 * @LastEditors: DESKTOP-FKE5GMS\17601 1760178806@qq.com
 * @LastEditTime: 2023-12-08 14:26:21
 * @FilePath: \合联\oms\src\api\analysis\adjustBillRecord.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import axios, { buildApi } from '@/libs/api.request';
let name = '/finance/statement/adjust'

export const apis = buildApi({
  get: [name + '/index&list', name + '/details/:id&detail'],
  post: []
})